import { render, staticRenderFns } from "./VacancyArchiveTableRow.vue?vue&type=template&id=b3b01a1c&scoped=true&"
import script from "./VacancyArchiveTableRow.vue?vue&type=script&lang=js&"
export * from "./VacancyArchiveTableRow.vue?vue&type=script&lang=js&"
import style0 from "./VacancyArchiveTableRow.vue?vue&type=style&index=0&id=b3b01a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b01a1c",
  null
  
)

/* custom blocks */
import block0 from "./VacancyArchiveTableRow.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyArchiveTableRow.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu,VProgressCircular})
